const DocumentUpload = () => {
  return <div>Carga de documentos</div>;
};

export default DocumentUpload;
